export default __webpack_public_path__ + "static/media/USA-1.386d5906.jpg";